var _path, _path2, _path3, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _path4, _path5, _circle, _circle2, _circle3, _circle4, _rect26, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHowToIllustrationInches(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 151,
    height: 179,
    viewBox: "0 0 151 179",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 107.882V43.9421C20 32.1433 29.6189 22.6331 41.3523 23.0109C52.5817 23.3886 61.3133 33.0988 61.3133 44.4976V107.882C61.3133 109.795 59.7682 111.346 57.8623 111.346H42.4692V137.626C42.5323 137.824 42.5598 138.034 42.5474 138.246L56.3024 172.253C56.649 173.111 56.2486 174.093 55.4085 174.447C55.2044 174.533 54.9906 174.575 54.7822 174.575C54.135 174.575 53.523 174.183 53.2597 173.535L42.4692 146.855V172.829C42.4692 173.776 41.6921 174.543 40.7346 174.543C39.7771 174.543 39 173.776 39 172.829V147.256L28.3715 173.536C28.1083 174.183 27.4963 174.575 26.8491 174.575C26.6407 174.575 26.4279 174.533 26.2228 174.447C25.3826 174.093 24.9823 173.111 25.3289 172.253L39 138.453V111.346H23.5073C21.5922 111.346 20.031 109.804 20 107.882Z",
    fill: "#969696"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8156 58.0787C48.0006 58.0787 53.8253 52.262 53.8253 45.0866C53.8253 37.9113 48.0006 32.0945 40.8156 32.0945C33.6305 32.0945 27.8059 37.9113 27.8059 45.0866C27.8059 52.262 33.6305 58.0787 40.8156 58.0787Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8159 51.5825C44.4084 51.5825 47.3207 48.6741 47.3207 45.0864C47.3207 41.4987 44.4084 38.5903 40.8159 38.5903C37.2234 38.5903 34.311 41.4987 34.311 45.0864C34.311 48.6741 37.2234 51.5825 40.8159 51.5825Z",
    fill: "#ACACAC"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 69,
    width: 28,
    height: 45,
    rx: 8,
    fill: "#0e0333"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 3,
    width: 22,
    height: 39,
    rx: 6,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 40,
    width: 2,
    height: 10,
    rx: 1,
    fill: "#0e0333"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 46,
    width: 2,
    height: 10,
    rx: 1,
    transform: "rotate(-90 36 46)",
    fill: "#0e0333"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 46,
    width: 2,
    height: 4,
    rx: 1,
    fill: "#0e0333"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 52,
    width: 2,
    height: 4,
    rx: 1,
    fill: "#0e0333"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 58,
    width: 2,
    height: 4,
    rx: 1,
    fill: "#0e0333"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 64,
    width: 2,
    height: 4,
    rx: 1,
    fill: "#0e0333"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 70,
    width: 2,
    height: 4,
    rx: 1,
    fill: "#0e0333"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 76,
    width: 2,
    height: 4,
    rx: 1,
    fill: "#0e0333"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 82,
    width: 2,
    height: 4,
    rx: 1,
    fill: "#0e0333"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 88,
    width: 2,
    height: 4,
    rx: 1,
    fill: "#0e0333"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 94,
    width: 2,
    height: 4,
    rx: 1,
    fill: "#0e0333"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 100,
    width: 2,
    height: 4,
    rx: 1,
    fill: "#0e0333"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 106,
    width: 2,
    height: 4,
    rx: 1,
    fill: "#0e0333"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 112,
    width: 2,
    height: 4,
    rx: 1,
    fill: "#0e0333"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 118,
    width: 2,
    height: 4,
    rx: 1,
    fill: "#0e0333"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 124,
    width: 2,
    height: 4,
    rx: 1,
    fill: "#0e0333"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 130,
    width: 2,
    height: 4,
    rx: 1,
    fill: "#0e0333"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 136,
    width: 2,
    height: 4,
    rx: 1,
    fill: "#0e0333"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 142,
    width: 2,
    height: 4,
    rx: 1,
    fill: "#0e0333"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 148,
    width: 2,
    height: 4,
    rx: 1,
    fill: "#0e0333"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 154,
    width: 2,
    height: 4,
    rx: 1,
    fill: "#0e0333"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 160,
    width: 2,
    height: 4,
    rx: 1,
    fill: "#0e0333"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 166,
    width: 2,
    height: 4,
    rx: 1,
    fill: "#0e0333"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 172,
    width: 2,
    height: 4,
    rx: 1,
    fill: "#0e0333"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    y: 179,
    width: 4,
    height: 97,
    rx: 2,
    transform: "rotate(-90 0 179)",
    fill: "#5C5C5C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M49 44.5C48.7239 44.5 48.5 44.7239 48.5 45C48.5 45.2761 48.7239 45.5 49 45.5V44.5ZM71.3536 45.3536C71.5488 45.1583 71.5488 44.8417 71.3536 44.6464L68.1716 41.4645C67.9763 41.2692 67.6597 41.2692 67.4645 41.4645C67.2692 41.6597 67.2692 41.9763 67.4645 42.1716L70.2929 45L67.4645 47.8284C67.2692 48.0237 67.2692 48.3403 67.4645 48.5355C67.6597 48.7308 67.9763 48.7308 68.1716 48.5355L71.3536 45.3536ZM49 45.5H71V44.5H49V45.5Z",
    fill: "#0e0333"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M113.646 175.354C113.842 175.549 114.158 175.549 114.354 175.354L117.536 172.172C117.731 171.976 117.731 171.66 117.536 171.464C117.34 171.269 117.024 171.269 116.828 171.464L114 174.293L111.172 171.464C110.976 171.269 110.66 171.269 110.464 171.464C110.269 171.66 110.269 171.976 110.464 172.172L113.646 175.354ZM114.354 44.6464C114.158 44.4512 113.842 44.4512 113.646 44.6464L110.464 47.8284C110.269 48.0237 110.269 48.3403 110.464 48.5355C110.66 48.7308 110.976 48.7308 111.172 48.5355L114 45.7071L116.828 48.5355C117.024 48.7308 117.34 48.7308 117.536 48.5355C117.731 48.3403 117.731 48.0237 117.536 47.8284L114.354 44.6464ZM114.5 175L114.5 45L113.5 45L113.5 175L114.5 175Z",
    fill: "#0e0333"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 78.5,
    cy: 9.5,
    r: 2.5,
    fill: "#0e0333"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 87.5,
    cy: 9.5,
    r: 2.5,
    fill: "#0e0333"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 87.5,
    cy: 16.5,
    r: 2.5,
    fill: "#0e0333"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 78.5,
    cy: 16.5,
    r: 2.5,
    fill: "#0e0333"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 24,
    width: 14,
    height: 14,
    rx: 4,
    fill: "#0e0333"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M130.48 109H131.989V99.1818H130.48V109ZM131.247 97.5455C131.835 97.5455 132.321 97.0852 132.321 96.5227C132.321 95.9602 131.835 95.5 131.247 95.5C130.659 95.5 130.173 95.9602 130.173 96.5227C130.173 97.0852 130.659 97.5455 131.247 97.5455ZM136.26 103.094C136.26 101.381 137.321 100.409 138.766 100.409C140.166 100.409 141.016 101.323 141.016 102.864V109H142.525V102.761C142.525 100.256 141.189 99.054 139.201 99.054C137.718 99.054 136.797 99.7188 136.337 100.716H136.209V99.1818H134.752V109H136.26V103.094Z",
    fill: "#0e0333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHowToIllustrationInches);
export default __webpack_public_path__ + "static/media/how-to-illustration-inches.4c4625e370c9607c53fc65a43538f404.svg";
export { ForwardRef as ReactComponent };